import React from 'react';
import Bar from './Bar';

const DocumentStatusBar = props => {
    return (
        <div className="DocumentStatusBar">
            <Bar
                orientation="horizontal"
                status={props.criticality}
                completed={props.percentage}
            />
            <div className="DSB-label">{props.count}</div>
        </div>
    );
};

export default DocumentStatusBar;

/*
<svg className='DocumentStatusBar' viewBox='0 0 100 100' preserveAspectRatio='none'>
    <rect className='background' x='0' y='0' width='100' height='100' />
    <rect className={props.criticality} y='0' height='100'
        x={0}
        width={props.percentage} />
</svg>
*/
